export default class RegionSelector {
    constructor(el) {
        this.el = el;
        this.location = null;
        this.modalDelay = 500;

        this.checkCookies();
    }

    checkCookies() {
        let location = Cookies.get('spsx_region');

        console.log('region',location);

        if(location) {
            this.location = location;
        } else {
            this.location = false;
            this.promptSetRegion();
        }
    }

    promptSetRegion() {
        console.log('SET REGION');
        setTimeout(() => {
            this.openSetRegionModal();
        }, this.modalDelay);
    }

    openSetRegionModal() {
        this.el.classList.add('spsx-modal--active', 'spsx-modal--fade-in');
    }

};
